import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { eventRefereeActions } from '../../_actions';

export const AddReferee = ({ id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(eventRefereeActions.referees(id));
    dispatch(eventRefereeActions.availableReferees(id));
  }, [dispatch, id]);

  const onRemove = (refereeId) => {
    if (!refereeId) return;
    dispatch(eventRefereeActions.removeReferee(id, refereeId));
  };

  const onAdd = (refereeId) => {
    if (!refereeId) return;
    dispatch(eventRefereeActions.addReferee(id, refereeId));
  };

  const { referees, allReferees, loading } = useSelector((s) => s.eventReferee);

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <h4>Event Referees</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <h5>Current Referees</h5>
          <div>
            {referees.map(({ id, name }) => (
              <Referee key={id}>
                <div>{name}</div>
                <Button
                  color="primary"
                  size="sm"
                  style={{ height: 'unset' }}
                  onClick={() => onRemove(id)}
                  disabled={loading}
                >
                  <FontAwesomeIcon color="white" icon="times" />
                </Button>
              </Referee>
            ))}
          </div>
        </Col>
        <Col>
          <h5>Add Referees</h5>
          <div>
            {allReferees.map(({ id, name }) => (
              <Referee key={id}>
                <div>{name}</div>
                <Button
                  color="primary"
                  size="sm"
                  style={{ height: 'unset' }}
                  onClick={() => onAdd(id)}
                  disabled={loading}
                >
                  <FontAwesomeIcon color="white" icon="plus" />
                </Button>
              </Referee>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const Referee = ({ children }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#F2F2F2',
      padding: '0.75rem',
      borderRadius: '1.5rem',
    }}
  >
    {children}
  </div>
);
